module.exports = __webpack_public_path__ + "img/Future100.60e74c9e.jpg";